export const getServicesManagerReactCode = (servicesManagerReactUrl: string) => `
  const s = window.servicesManagerReact || await import('${servicesManagerReactUrl}');

  const WixServices = s.WixServices;
  const useServices = s.useServices;
  const useService = s.useService;
  const useGetService = s.useGetService;
  const ServicesManagerProvider = s.ServicesManagerProvider;
  
  export { WixServices, useServices, useService, useGetService, ServicesManagerProvider };
`
